$(function(){
    $(".newsletter-form").on("submit", function (e) {
        e.preventDefault();
        var $name = $('input[name=name]', this),
            $email = $('input[name=email]', this),
            $newsletterMessage = $('#message-newsletter'),
            $submit = $('input[type=submit]', this),
            $inputs = $('input', this)

        $submit.val('Cadastrando...');

        $inputs.prop('disabled', true);

        var data = {
                name: $name.val(),
                email: $email.val(),
            },
            url =
                document.location.protocol +
                "//" +
                document.location.hostname +
                "/api/email-marketing/novo";

        $.ajax({
            data: data,
            url: url,
            type: "POST",

            success: function (response) {
                $newsletterMessage.text(response[1]);

                $name.val("");
                $email.val("");
                $submit.val("Cadastrar");
                $inputs.prop('disabled', false);
            },

            fail: function (response) {
                $newsletterMessage.text(response[1]);
                $submit.val("Cadastrar");
                $inputs.prop('disabled', false);
            },

            complete: function (response) {
                console.log(response.statusText)
                if (
                    response.statusText === "Unprocessable Entity" ||
                    response.responseJSON.email[0] === "O e-mail já está cadastrado"
                ) {
                    var error = JSON.parse(response.responseText);

                    var message = error['g-recaptcha-response'] || error.email[0];
                    $newsletterMessage.text(message);
                    $submit.val("Cadastrar");
                    $inputs.prop('disabled', false);
                }
            },
        });
    })
})